'use client';

import Image from "@src/components/atoms/safe-image"

const ThemeGold = `bg-yellow-0 border border-solid border-yellow-0 
  disabled:bg-white-4 disabled:text-grey-6 disabled:border-grey-6`
const ThemeWhite = `bg-white-3 border border-solid border-black-1 
  disabled:bg-white-4 disabled:text-grey-6 disabled:border-grey-6`
const btnClass = `flex items-center justify-center w-fit px-[18px] py-[14px] cursor-pointer rounded-[80px] flex items-center justify-center text-15 font-sfpro-heavy text-black-1 
  hover:bg-black-1 hover:text-white-3`

const Button = ({
  text,
  className,
  icon,
  disabled,
  iconPosition = "left",
  theme = "gold",
  ...props
}) => {
  const themeClass = theme === "gold" ? ThemeGold : ThemeWhite;

  return (
    <button disabled={disabled} className={`${btnClass} ${themeClass} ${className}`} {...props}>
      {!!icon && iconPosition === "left" && <Image disabled={disabled} src={icon} alt="Icon" className={`cursor-pointer w-4 h-4 mr-1 ${disabled && "opacity-50"}`} width="auto" height="auto" />}
      {text}
      {!!icon && iconPosition === "right" && <Image disabled={disabled} src={icon} alt="Icon" className={`cursor-pointer w-4 h-4 ml-1 ${disabled && "opacity-50"}`} width="auto" height="auto" />}
    </button>
  )
}

export default Button